import { Checkbox, Form, Spin } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import Box from "./Box";

type Props = {
  ser: { name: string; id: Number; icon: any }[];
  isLoading: boolean;
};

const Services = ({ ser, isLoading }: Props) => {
  const intl = useIntl();
  return (
    <div className="text-center xl:px-24 xl:py-4 max-xl:py-8 max-xl:px-2">
      <h3 className="font-medium text-lg max-lg:!text-base text-color-primary max-md:text-base">
        <FormattedMessage
          id="services_header"
          defaultMessage="What services do you offer?"
        />
      </h3>
      <p className="my-4 text-sm text-gray-500 max-md:text-xs ">
        <FormattedMessage
          id="services_description"
          defaultMessage="Choose your services to make your experience tailored just for you!"
        />
      </p>
      <Form.Item
        name="service_id"
        rules={[
          {
            required: true,
            message: intl.formatMessage({ id: "service_required" }),
          },
        ]}
        className="lg:px-24 lg:py-4"
        hasFeedback
      >
        {isLoading ? (
          <Spin />
        ) : (
          <Checkbox.Group className="flex flex-wrap justify-center gap-8 p-2 max-md:flex-col max-xl:gap-3 items-right">
            {ser?.map(({ name, id, icon }, i) => {
              return <Box key={i} title={name} icon={icon} id={id} />;
            })}
          </Checkbox.Group>
        )}
      </Form.Item>
    </div>
  );
};

export default Services;
